var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outcome"},[(_vm.questionnaire)?_c('QuestionnaireCard',{key:_vm.questionnaire,attrs:{"questionnaire":_vm.questionnaire}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }